import { render, staticRenderFns } from "./Indicacao.vue?vue&type=template&id=f2bfeb86&"
import script from "./Indicacao.vue?vue&type=script&lang=js&"
export * from "./Indicacao.vue?vue&type=script&lang=js&"
import style0 from "./Indicacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports